import AxiosInstance from "./api";

export const MaterialsStockReportService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/materials-stock-report", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/materials-stock-report/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/materials-stock-report", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/materials-stock-report/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/materials-stock-report/${id}`);
  },
};
